import React from 'react';
import _ from 'underscore';

import { InlineEditableDescriptionProps, InlineEditableDescription } from '../../app/spaces/Header/InlineEditableDescription';
import { DESCRIPTION_MAX_LENGTH } from '../constants/lensconstants';
import { LensSpaceHeaderProps } from './LensSpaceHeader';
import { Messages } from '../../codegen/Localize';
import { LensesTAGHandler } from '../api/LensTAG';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';

export interface EditableLensDescriptionInlineProps extends LensSpaceHeaderProps {
  readonly canEdit: boolean;
  readonly onEditChange: (isEditing: boolean) => void;
}

export function EditableLensDescriptionInline(props: EditableLensDescriptionInlineProps): JSX.Element {

  const updateDescription = async (description: string) => {
    try {
      await LensesTAGHandler.editDescription(props.item.id, description);
      ToasterService.instance.pop({ type: ToastType.Success, text: Messages.lensDescription_Toast_Success()});
    } catch (e) {
      ToasterService.instance.pop({ type: ToastType.Error, text: Messages.lensDescription_Toast_Error()});
    }
    props.reloadSpace();
  };

  const descriptionProps: InlineEditableDescriptionProps = {
    ...props,
    maxCharacterCount: DESCRIPTION_MAX_LENGTH,
    updateDescription: updateDescription,
    sanitizer: props.sanitizer,
    canEdit: props.canEdit,
    onEditChange: props.onEditChange,
    descriptionPrompt: props.canEdit ? Messages.lensDescriptionPrompt(): '',
    isAdminOrOwner: true,
    ariaLabel: Messages.lensDescription_TextArea_Label()
  };

  return <InlineEditableDescription {...descriptionProps} />;
}
